import { useInfiniteQuery } from 'react-query';
import { AxiosError } from 'axios';

import { PostCommentsResponse } from '@common/types/api';
import { api } from '@services';

const COMMENTS_PER_PAGE = 10;

const fetchPostComments = async (
  postId: number,
  page: number,
): Promise<PostCommentsResponse> => {
  const { data } = await api.get<PostCommentsResponse>(
    `/timeline/${postId}/comments`,
    { params: { page, limit: COMMENTS_PER_PAGE } },
  );

  return data;
};

export const usePostCommentsQuery = (postId: number, enabled: boolean) =>
  useInfiniteQuery<PostCommentsResponse, AxiosError>(
    ['post-comments', postId],
    ({ pageParam = 1 }) => fetchPostComments(postId, pageParam),
    {
      enabled,
      getNextPageParam: (lastPage) => {
        const { current_page, total_pages } = lastPage.meta.pagination;
        return current_page < total_pages ? current_page + 1 : undefined;
      },
    },
  );
